import { PostCallChat } from 'features/calls/components'
import { ICall } from 'features/calls/types'
import { IClaim } from 'features/claims/types'
import { ObModal } from '@outbound-ai/ursa'

import styled, { useTheme } from 'styled-components'

interface IProps {
  show: boolean
  setShow: React.Dispatch<React.SetStateAction<boolean>>
  claim: IClaim
  call: ICall
  callIndex: number
  totalCalls: number
}
export const ViewCallTranscriptModal = ({ show, setShow, claim, call, callIndex, totalCalls }: IProps) => {
  const theme = useTheme()

  const callStartTime: Date = new Date(call.jobStarted ?? call.jobRequested ?? call.jobQueued)

  const callEndTime: Date = new Date(call.jobCompleted ?? callStartTime)

  const callDuration = Math.round(Math.abs(callEndTime.getTime() - callStartTime.getTime()) / 1_000)

  const postCallChatStyles = `
  border: 1px solid ${theme.colors.primary.lightest};
  height: ${theme.util.pixelToRem(550)};
  `

  return (
    <div>
      <ObModal
        show={show}
        close={() => setShow(false)}
        size="lg"
        title={`Test Call ${callIndex + 1} of ${totalCalls}`}
        height="auto"
      >
        <InnerContainer>
          <section className="call-details-container">
            <h3>Call Details</h3>
            <section className="call-details">
              <div>
                <span>Date Conducted</span>
                <span>{callStartTime.toLocaleDateString()}</span>
              </div>
              <div>
                <span>Call Time</span>
                <span>
                  {callStartTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })} -
                  {callEndTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}
                </span>
              </div>
              <div>
                <span>Call Duration</span>
                <span>{callDuration}s</span>
              </div>
            </section>
          </section>
        </InnerContainer>
        <PostCallChat claim={claim} call={call} styles={postCallChatStyles} />
      </ObModal>
    </div>
  )
}

const InnerContainer = styled.div`
  .call-details-container {
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5rem;
    h3 {
      font-size: 1rem;
      font-weight: bold;
      color: ${({ theme }) => theme.colors.primary.darker};
      margin-bottom: 1rem;
    }
    .call-details {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      div {
        display: flex;
        flex-direction: column;
        span:first-child {
          font-size: ${({ theme }) => theme.typography.s.medium};
          color: ${({ theme }) => theme.colors.grey.light};
          margin-bottom: 0.25rem;
        }
        span:last-child {
          font-size: ${({ theme }) => theme.typography.s.medium};
          color: ${({ theme }) => theme.colors.grey.darker};
        }
      }
    }
  }
`
